export default __webpack_public_path__ + "static/media/informativo-cabecalho.8c47ddda.png";